import { Text, View } from "@react-pdf/renderer";
import { globalStyles } from "config/pdfStyles";
import { isEmpty } from "lodash";

const AnswerDD = ({ answer, question }) => {
  const ddLabels = question?.question_dd_labels;
  const anwerDDLabels = answer?.answer?.other_details?.dd_labels;

  // if(!ddLabels?.length || isEmpty(anwerDDLabels)) {
  //   return "--";
  // }

  return (
    <View>
      <View style={[ globalStyles.standardBorder, { borderRadius: "5px", padding: "10px" } ]}>
        <View style={{ marginBottom: "10px" }}>
          <View>
            <Text style={globalStyles.reportQuestion}>
              {ddLabels[0]}:
            </Text>
            <Text>
              {anwerDDLabels?.name}
            </Text>
          </View>
        </View>
        {ddLabels?.length && !isEmpty(anwerDDLabels) && (
          <View style={{ marginBottom: "10px" }}>
            <Text style={globalStyles.reportQuestion}>
              {ddLabels[1]}:
            </Text>
            <Text>
              {anwerDDLabels?.description}
            </Text>
          </View>
        )}
        <Text>
          {answer?.answer?.answer || "--"}
        </Text>
      </View>
    </View>
  )
}

export default AnswerDD;